<template>
    <div class="main">
		<!-- <a-button v-on:click="getdata" >测试</a-button> -->
        <Table
            :columns="columns"
            :request="request"
            row-key="id"
            :searchData ="searchData"
            :formData="formData"
			:saveinputs="saveinputs"
        >
        <template v-slot:formItem>
           <a-form-model-item >
               <a-input v-model="searchData.wxname" allowClear  placeholder="请输入用微信昵称"/>
           </a-form-model-item> 
           <a-form-model-item >
               <a-input v-model="searchData.username" allowClear  placeholder="请输入用姓名"/>
           </a-form-model-item> 
           <a-form-model-item >
               <a-input v-model="searchData.idcard" allowClear  placeholder="请输入身份证号码"/>
           </a-form-model-item> 
           <a-form-model-item >
               <a-input v-model="searchData.phonenum" allowClear  placeholder="请输入用电话号码"/>
           </a-form-model-item> 
           <a-form-model-item  :hidden="user.cmpid !=-1">
               <a-select placeholder="请选择公司"  style="width:120px" allowClear v-model="searchData.cmpid">
                     <a-select-option v-for="item in cmps" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
           </a-form-model-item> 
        </template>

        <template v-slot:tableAction="{record,showModal,showDelConfirm}">
           <a class="tAction" @click="updateuser(record,showModal)"><a-icon type="edit" />修 改</a>
           <a-divider type="vertical" />
           <a class="tAction" @click="deleteUser(record,showDelConfirm)"><a-icon type="delete" /> 删 除</a>
        </template>
        <template v-slot:tableIndex="index">
            {{index+1}}
        </template>

        <template v-slot:addAction="{showModal}">
            <a-form-model-item>
                <a-button type="primary" @click="addUser(showModal)"><a-icon type="plus" /> 添加</a-button>
            </a-form-model-item>
        </template>
		<template v-slot:company="{text}">
			{{getcmpname(text)}}
        </template>

        <template   v-slot:itemFormData>
			<a-form-model-item v-if="user.cmpid == -1" label="公司">
				<a-select placeholder="请选择公司" v-model="formData.cmpid">
                     <a-select-option v-for="item in cmps" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
			</a-form-model-item>
        </template>
        </Table>
    </div>
</template>

<script>
import UserMng from "./index.js"
export default UserMng
</script>

<style lang="less" scoped>
@import "./index";
</style>
